import template	from "./dialog-config.html";
import css		from "./dialog-config.css";

import Dialog	from "dialog";


class ConfigWebCamDialog extends Dialog {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  connectedCallback(...args) {
    super.connectedCallback(...args);
    
    this.canvas = this.division1.appendChild( document.createElement("canvas") );
    this.canvas.setAttribute("width", "640");
    this.canvas.setAttribute("height", "480");
    this.canvas.style.width = "100%";
    this.canvas.style.height = "100%";
    
    this.ws = new WebSocket(`${window.location.protocol==="https:" ? "wss:" : "ws:"}//${window.location.host}/webcam.jss?sessid=ADFLHAHFADFG`, "videostream");
    this.ws.binaryType = "arraybuffer";
    this.ws.onmessage = this.updateFrame.bind(this);    
    
  }
  disconnectedCallback(...args) {
    super.disconnectedCallback(...args);
    
    this.ws.close();
  }
  static constructor() {
    customElements.define("fulljs-dialog-config-webcam", ConfigWebCamDialog);
  }
  constructor(...args) {
    super(...args);

    this.show(...args);
  }
 updateFrame(event) {
    const received_msg = new Uint8ClampedArray(event.data);

    if(received_msg.length > 0) {
      const ctx = this.canvas.getContext("2d");		
      const imgData = ctx.createImageData(640, 480);
      const grayScale = new Uint8Array(640*480);
      let i, j, g;
      for (i = 0, j = 0, g = 0; i < imgData.data.length && j < received_msg.length; i += 8, j += 4, g+= 2) {
        const y1  = received_msg[j  ];
        const u   = received_msg[j+1];
        const y2  = received_msg[j+2];
        const v   = received_msg[j+3];

        grayScale[g]   = y1;
        grayScale[g+1] = y2;
        imgData.data[i    ] = Math.min(255, Math.max(0, Math.floor(y1+1.4075*(v-128))));
        imgData.data[i + 1] = Math.min(255, Math.max(0, Math.floor(y1-0.3455*(u-128)-(0.7169*(v-128)))));
        imgData.data[i + 2] = Math.min(255, Math.max(0, Math.floor(y1+1.7790*(u-128))));
        imgData.data[i + 3] = 255;
        imgData.data[i + 4] = Math.min(255, Math.max(0, Math.floor(y2+1.4075*(v-128))));
        imgData.data[i + 5] = Math.min(255, Math.max(0, Math.floor(y2-0.3455*(u-128)-(0.7169*(v-128)))));
        imgData.data[i + 6] = Math.min(255, Math.max(0, Math.floor(y2+1.7790*(u-128))));
        imgData.data[i + 7] = 255;
      }
      ctx.putImageData(imgData, 0, 0);    
    }  
  }  
  buttonClose_click() {
    this.close();
  }
}

ConfigWebCamDialog.constructor();

export default ConfigWebCamDialog;